// extracted by mini-css-extract-plugin
export default {"avatar":"SupplementaryMaterials_avatar__C+5Zf"};